export async function Login(apiInstance, credentials) {
  try {
    const response = await apiInstance.post(`/User/Login`, credentials);
    return response.data;
  } catch (err) {
    console.error("Login error details:", {
      message: err.message,
      status: err.response?.status,
      data: err.response?.data,
      config: err.config,
    });
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}
